/* eslint-disable no-unused-vars */
import C from "../../constants/userStatus.js";
import store from "../store.js";
import axios from "axios";
import lod_ from "lodash";
import { api } from "./api.js";
import notificationActions from "redux/actions/notificationActions.js";
import { fetchNotificationsSuccess, setUnreadCount } from "redux/reducers/notificationsReducer.js";
import Cookies from "universal-cookie";
// require("dotenv").config();
const endPoint = process.env.REACT_APP_AMBACK;
const cookies = new Cookies();

const actions = {
	addUserData: function (user, currentAssistant, assistantIDs, cb) {
		let assistantID = currentAssistant;

		return dispatch => {
			axios(endPoint + "/api/profile", {
				headers: {
					Authorization: `Bearer ${user.token}`,
					UserEmail: user.email
				},
				method: "POST",
				data: {
					email: user.email,
					assistantID,
					assistantIDs
				}
			})
				.then(additionalUserData => {
					dispatch({
						type: C.ADD_USER_DATA,
						payload: {
							user: {
								...user,
								...additionalUserData.data
							}
						}
					});

					// Appel API for notifications after user data is loaded to have the assistantID in the header
					if (!lod_.isEmpty(assistantID)) {
						dispatch(
							notificationActions.getNotifications(
								undefined,
								datas => {
									const res = datas?.payload || {};
									if (!lod_.isNil(res?.notifications) && Array.isArray(res.notifications)) {
										const unreadCount = res.notifications.filter(n => n.read !== true).length;
										dispatch(fetchNotificationsSuccess(res));
										dispatch(setUnreadCount(unreadCount));
									}
								},
								res => {
									// Reset notifications on error to prevent infinite loading
									dispatch(fetchNotificationsSuccess({ notifications: [], unreadCount: 0 }));
								}
							)
						);
					}

					localStorage.setItem("hasRefreshed", "false");

					cb();
				})
				.catch(error => {
					cookies.remove("fAIbrik.selectedAssistantID", { path: "/" });
					cookies.remove("fAIbrik.selectedAssistantID", { path: "/admin" });

					// Refresh la page une seule fois
					if (localStorage.getItem("hasRefreshed") === "false") {
						localStorage.setItem("hasRefreshed", "true");
						window.location.reload();
					}
				});
		};
	},

	saveUserdata: function (profilToUpdate, successCallback, errorCallback) {
		if (lod_.has(store.getState().userStatus, "auth.user")) {
			let user = store.getState().userStatus.auth.user;
			let assistantID = store.getState().selectedAssistantID;
			const data = {
				email: user.email,
				user: profilToUpdate,
				assistantID
			};
			return dispatch => {
				axios(endPoint + "/api/saveprofile", {
					headers: {
						Authorization: `Bearer ${user.token}`,
						UserEmail: user.email
					},
					method: "POST",
					data: data
				})
					.then(res => {
						dispatch({
							type: C.SAVE_USER_DATA,
							payload: profilToUpdate
						});

						if (successCallback) {
							successCallback(profilToUpdate);
						}
					})
					.catch(err => {
						if (errorCallback) {
							errorCallback();
						}
					});
			};
		}
	},
	saveUsersFilter: function (userEmails, dataToUpdate, successCallback, errorCallback) {
		if (lod_.has(store.getState().userStatus, "auth.user")) {
			let user = store.getState().userStatus.auth.user;
			let assistantID = store.getState().selectedAssistantID;
			const data = {
				email: user.email,
				userEmails,
				dataToUpdate,
				assistantID
			};

			return () => {
				axios(endPoint + "/api/saveFilterOnProfiles", {
					headers: {
						Authorization: `Bearer ${user.token}`,
						UserEmail: user.email
					},
					method: "POST",
					data: data
				})
					.then(() => {
						// DELETED BECAUSE REMOVE FILTER OF CURRENT USER
						// dispatch({
						// 	type: C.SAVE_USER_PROFILE,
						// 	payload: dataToUpdate
						// });

						if (successCallback) {
							successCallback(dataToUpdate);
						}
					})
					.catch(err => {
						if (errorCallback) {
							errorCallback();
						}
					});
			};
		}
	},
	resetPassword: (infos, successCb, failCb) => {
		let user = store.getState().userStatus.auth.user;

		if (user.sub) {
			infos = {
				...infos,
				auth0Id: user.sub
			};
		}

		if (user.email) {
			infos = {
				...infos,
				_id: user.email
			};
		}

		const data = {
			email: user.email,
			user: infos
		};

		return () => {
			axios
				.put(`${endPoint}/api/resetPassword`, data, {
					headers: {
						Authorization: `Bearer ${user.token}`,
						UserEmail: user.email
					}
				})
				.then(res => {
					if (res.status === 200) {
						successCb();
					} else {
						failCb();
					}
				})
				.catch(err => {
					failCb();
				});
		};
	},

	saveOptionUser: function (data) {
		let user = store.getState().userStatus.auth.user;
		let assistantID = store.getState().selectedAssistantID;
		return dispatch => {
			dispatch(
				api({
					type: "cockpit/saveOptionUser",
					url: "/api/v1/saveOptionUser",
					headers: {
						Authorization: `Bearer ${user.token}`,
						UserEmail: user.email
					},
					method: "POST",
					data: { ...data, user, assistantID },
					onSuccess: res => {
						dispatch({
							type: C.SAVE_USER_DATA,
							payload: res
						});
					}
				})
			);
		};
	}
};

export default actions;
